import { type ReactNode } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { FloatingTooltip } from '@/components/common/Floating'

import styles from './Footnote.module.scss'

type Props = {
  content: ReactNode
  title?: string
}

export const Footnote = ({ content, title }: Props) => (
  <FloatingTooltip content={title && <p>{title}</p>} placement='bottom' styled>
    <ButtonRoot as='span' className={styles.container}>
      {content}
    </ButtonRoot>
  </FloatingTooltip>
)
